import apiFetch from '../apiFetch'

export default function (idProducto) {
  return apiFetch({endPoint: `Combos/getComboLotes?idProducto=${idProducto}`, method: 'GET', body: null})
}